import SignupShell from '../../../components/SignupShell';
import React, { useEffect, useState } from "react";
import { billingEnabled } from '../../../billing/api';
import HeaderText from "../../../common/HeaderText";
import { Box, Button, Grid, Typography, Link } from "@mui/material";
import Textfield from "../../../common/Textfield";
import { Link as LinkTo, Navigate, useLocation, useNavigate } from "react-router-dom";
import CircularProgressLoading from "../../../common/CircularProgress";
import AlertMessage from "../../../common/AlertMessage";
import { useDispatch, useSelector } from "react-redux";
import {
  createWorkspaceFunc,
  resetUpdateAgentProfile,
} from "../../../actions/Agency";
import { LoadingButton } from "@mui/lab";
import Cookies from 'js-cookie';

const CreateWorkspace = () => {
  const [firmName, setFirmName] = useState("");
  const [errorMessage, setErrorMessage] = useState("");

  const navigate = useNavigate();
  const { state } = useLocation();

  const agentData = state && state?.agentData;
  const acceptance = state?.legalAcceptance;
  const termsAccepted = state?.termsOfService === true && Boolean(acceptance?.id) &&
    acceptance?.actor_type === 'agent' && acceptance?.source === 'web' &&
    acceptance?.actor_id === Number(agentData?.agent?.id) && Boolean(agentData?.token);

  const dispatch = useDispatch();
  const createWorkspace = useSelector((state) => state.createWorkspace);
  const { loading, error, workspace } = createWorkspace;

  useEffect(() => {
    if (termsAccepted && Cookies.get('token') === agentData.token && !error && workspace?.data?.ok) {
      navigate("/create-agentname", { state: { createWorkspace: true } });
    }
  }, [workspace, termsAccepted]);

  useEffect(() => {
    if (termsAccepted && Cookies.get('token') === agentData.token && agentData?.existing_agencies?.length) {
      // setErrorMessage(
      //   ` An account with this email already exists. Please login or reset password to access your account`
      // );

      navigate("/");
    }
  }, [agentData, termsAccepted]);

  const [open, setOpen] = useState(false);
  const [emailError, setEmailError] = useState(false);

  const handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpen(false);
  };

  const createWorkspaceHandler = async (e) => {
    e.preventDefault();
    if (!termsAccepted) return;
    if (Cookies.get('token') !== agentData.token) {
      setErrorMessage('Your account changed. Please restart signup.');
      setOpen(true);
      return;
    }

    dispatch(resetUpdateAgentProfile());

    if (!firmName) {
      setEmailError(true);
      return;
    }

    setEmailError(false);

    const data = {
      name: firmName,
    };

    dispatch(createWorkspaceFunc({ agency: data }, agentData.token));
    setOpen(true);
    // navigate("/create-password");
  };

  if (!agentData?.agent?.id) return <Navigate to="/register" replace />;
  if (!termsAccepted) return <Navigate to="/terms-of-service" replace state={{ agentData }} />;

  return (
    <>
      {!loading && error && (
        <AlertMessage
          message={error}
          severity="error"
          open={open}
          handleClose={handleClose}
        />
      )}

      {!loading && errorMessage && (
        <AlertMessage
          message={errorMessage}
          severity="warning"
          open={open}
          handleClose={handleClose}
        />
      )}
      <SignupShell>

          <Grid container component="main">
            <Box
              component="form"
              onSubmit={createWorkspaceHandler}
              xs={12}
              display="flex"
              gap="40px"
              flexDirection="column"
              width="100%"
            >
              <Box>
                <Typography
                  variant="body1"
                  className="d-flex"
                  fontSize={16}
                  mb="16px"
                  color="#566875"
                >
                  Step 1 of {billingEnabled ? 4 : 2}
                </Typography>
                <HeaderText
                  variant="h3"
                  fontSize={32}
                  textContent="What is the name of your Law Firm?"
                  lineHeight="116.7%"
                  textAlign="initial"
                />
                <Typography
                  variant="body1"
                  className="d-flex"
                  fontSize={16}
                  mt="16px"
                  color="#566875"
                >
                  This will also be the name of your workspace.
                </Typography>
              </Box>

              <Box display="flex" flexDirection="column" gap="16px">
                <Textfield
                  value={firmName}
                  onChange={(e) => setFirmName(e.target.value)}
                  variant="outlined"
                  name="firmName"
                  helperText={
                    !firmName &&
                    emailError &&
                    "Please enter your law firm name!"
                  }
                  errorContent={
                    !firmName &&
                    emailError &&
                    "Please enter your law firm name!"
                  }
                />
              </Box>
              <LoadingButton
                loading={loading}
                fullWidth
                type="submit"
                variant="contained"
                sx={{ padding: "8px 22px", fontSize: 15 }}
              >
                Next
              </LoadingButton>

              {/* <Button
        className="w-100"
        fontSize="15px"
        color="primary"

        title="Sign In"
        variant="contained"
        width="100%"
        height="48px"
        // disabled={!fieldVals?.email || !fieldVals?.password} // Disabling it off on purpose
        // onClick={() => onSignIn()}
        // loading={signInLoading}
        loadingColor="primary"
      /> */}
            </Box>
          </Grid>
        </SignupShell>
    </>
  );
};

export default CreateWorkspace;
